import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=4c84b320&"
import script from "./StickyHeader.vue?vue&type=script&lang=js&"
export * from "./StickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeader.vue?vue&type=style&index=0&id=4c84b320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports